import { render, staticRenderFns } from "./EmailChangeConfirm.vue?vue&type=template&id=5ce86146&"
import script from "./EmailChangeConfirm.vue?vue&type=script&lang=js&"
export * from "./EmailChangeConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports